module.exports = __webpack_public_path__ + "static/media/fly0164.a07d1cb8.webp";